module.exports = __webpack_public_path__ + "img/question-mark.c6d536d6.svg";